import BalancesList from '@/components/clients/lists/balances-list';
import CardsList from '@/components/clients/lists/cards-list';
import ClientsList from '@/components/clients/lists/clients-list';
import MessagesList from '@/components/clients/lists/messages-list';
import PhonesList from '@/components/clients/lists/phones-list';
import PushesList from '@/components/clients/lists/pushes-list';
import DeviceLogsList from '@/components/clients/lists/device-logs-list';
import UssdList from '@/components/clients/lists/ussd-list';
import ClientsToolbar from '@/components/clients/clients-toolbar';
import { $clientsListType } from '@/entities/clients-filter.entity';
import { useUnit } from 'effector-react';

export type { ClientsListType } from '@/entities/clients-filter.entity';

export default function ClientsPage() {
	const listType = useUnit($clientsListType);

	return (
		<main className='h-full min-h-0 flex flex-col overflow-hidden'>
			<div className='shrink-0 sticky top-0 z-10 px-2 pt-2 bg-background/95 backdrop-blur-sm'>
				<ClientsToolbar />
			</div>
			<div className='flex-1 basis-0 min-h-0 px-2 pb-2'>
				{listType === 'messages' && <MessagesList />}
				{listType === 'pushes' && <PushesList />}
				{listType === 'deviceLogs' && <DeviceLogsList />}
				{listType === 'ussd' && <UssdList />}
				{listType === 'clients' && <ClientsList />}
				{listType === 'balances' && <BalancesList />}
				{listType === 'cards' && <CardsList />}
				{listType === 'phones' && <PhonesList />}
			</div>
		</main>
	);
}
